import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { IconFilePDF } from '@xing-com/icons';
import {
  spaceS,
  spaceM,
  spaceL,
  xdlColorTextSecondary,
  xdlColorBackgroundTertiary,
  scale110,
} from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

export const StyledDocumentDetails = styled.div<{ $isMultiple?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spaceM};
  padding: ${spaceM};
  background-color: ${xdlColorBackgroundTertiary};
  margin-bottom: ${({ $isMultiple }) => ($isMultiple ? spaceL : 0)};
`;

export const StyledWrapper = styled.div`
  flex-grow: 1;
`;

export const StyledIcon = styled(IconFilePDF)`
  flex-shrink: 0;
  width: ${scale110};
`;

export const StyledTextWrapper = styled.span`
  display: flex;
  color: ${xdlColorTextSecondary};
  gap: ${spaceS};
`;

export const StyledText = styled(BodyCopy)`
  color: ${xdlColorTextSecondary};
  white-space: nowrap;
`;

export const StyledButton = styled(Button)`
  flex-shrink: 0;
`;

export const StyledHeadline = styled(Headline)`
  overflow-wrap: anywhere;
`;
